const A = "/brand";

const primary = {
  name: "Sarah M.",
  role: "Vision Book Workshop",
  quote: "I wasn't broken. I had just been following someone else's map.",
};

const pullQuotes = [
  {
    name: "Emily R.",
    role: "Consistency Corner",
    quote: "The group experience gave me community when I needed it most.",
  },
  {
    name: "Jennifer K.",
    role: "Spark Sessions",
    quote: "I didn't need more inspiration. I needed someone to help me clear the fog.",
  },
  {
    name: "Rachel T.",
    role: "Vision Book Workshop",
    quote: "I walked in overwhelmed and walked out with a plan I could actually use.",
  },
];

export function WorkWithMeTestimonials() {
  return (
    <section
      data-testid="work-testimonials-section"
      className="relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[38px] md:pt-[51px] pb-12 md:pb-16 relative z-[1]">
        
        <div className="mb-10 md:mb-14 reveal">
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1C1917]">
            Stories From the Journey
          </h2>
        </div>

        {/* Primary testimonial - magazine pull quote style */}
        <figure
          data-testid="work-testimonial-primary"
          className="reveal mb-[70px] md:mb-[88px]"
        >
          <blockquote className="max-w-[986px]">
            <span
              className="font-display text-[83px] md:text-[110px] leading-none mb-4 block select-none"
              style={{ color: "#159E9A" }}
              aria-hidden
            >
              &ldquo;
            </span>
            <p className="font-display text-[42px] md:text-[56px] lg:text-[64px] leading-[1.08] tracking-tight text-[#1C1917] -mt-12">
              {primary.quote}
            </p>
          </blockquote>
          <figcaption className="mt-8">
            <div className="w-12 h-px bg-[#159E9A] mb-4" />
            <p className="text-sm font-medium tracking-[0.12em] uppercase text-[#1C1917]">
              {primary.name}
            </p>
            <p className="text-sm text-[#78716C] mt-1">{primary.role}</p>
          </figcaption>
        </figure>

        <div className="w-full h-px bg-[#E8E6E3] mb-[53px] md:mb-[70px]" />

        {/* Three short pull quotes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">
          {pullQuotes.map((t, i) => (
            <figure
              key={i}
              data-testid={`work-testimonial-${i}`}
              className="reveal flex flex-col"
            >
              <span
                className="font-display text-[55px] md:text-[69px] leading-none mb-4 block select-none"
                style={{ color: "#159E9A" }}
                aria-hidden
              >
                &ldquo;
              </span>
              <blockquote className="font-display text-2xl md:text-3xl leading-tight text-[#1C1917] mb-6 -mt-6">
                {t.quote}
              </blockquote>
              <figcaption>
                <div className="w-8 h-px bg-[#159E9A] mb-4" />
                <p className="text-sm font-medium tracking-[0.12em] uppercase text-[#1C1917]">
                  {t.name}
                </p>
                {t.role && (
                  <p className="text-sm text-[#78716C] mt-1">{t.role}</p>
                )}
              </figcaption>
            </figure>
          ))}
        </div>

      </div>
    </section>
  );
}
